import { CertificateOut } from '../types/apiRequests'

export const getCommonName = (record: CertificateOut | undefined): string => {
    if (record?.metaData) {
        return (record.metaData as { commonName?: string }).commonName || ''
    }
    return ''
}
